import { setElementInert } from '../../util/a11y/handle-inert';

export default {
  init() {
    const $ytPlayers = document.querySelectorAll('.yt-player');

    if (!$ytPlayers.length) {
      return;
    }

    window.MSRecipeVideos = window.MSRecipeVideos || {};

    // this.startListener(bubbles);
    $ytPlayers.forEach($ytPlayer => {
      if ( !window.YT ) {
        this.loadYoutubeScripts($ytPlayer);
      } else {
        this.loadYoutubePlayer($ytPlayer);
      }
    });
  },

  // eslint-disable-next-line
  loadYoutubeScripts($ytPlayer) {
    // 2. This code loads the IFrame Player API code asynchronously.
    var tag = document.createElement('script');

    tag.src = 'https://www.youtube.com/iframe_api';
    var firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

    window.addEventListener('load', () => {
      if(!window.YT) {
        return;
      }

      this.loadYoutubePlayer($ytPlayer);
    });
  },

  loadYoutubePlayer($ytPlayer) {

    const videoId = $ytPlayer.dataset.vidId;
    const isWysiwygVideo = $ytPlayer.classList.contains('ms-media__video');
    const isRecipeVideo = $ytPlayer.classList.contains('ms-recipe-media__video');
    const ytContainer = $ytPlayer.parentElement;

    const autoplay = $ytPlayer.dataset.autoplay === 'false' ? 0 : 1; // default true
    const thumbnail = $ytPlayer.dataset.thumbnail === 'true' ? true : false; // default false
    const withVideoLabel = $ytPlayer.dataset.withVideoLabel === 'true' ? true : false; // default false
    const withControls = $ytPlayer.dataset.withControls === 'false' ? 0 : 1; // default true
    const playerVars = isRecipeVideo || isWysiwygVideo ?
    {
      'autoplay': 0,
      'controls': withControls,
      'enablejsapi': 1,
      'mute': 0,
      'modestbranding': 1,
      'rel': 0,
      'disablekb': 1,
      'playsinline': 1,
    } :
    {
      'autoplay': autoplay,
      'controls': 0,
      'mute': 1,
      'modestbranding': 1,
      'rel': 0,
      'disablekb': 1,
      'playsinline': 1,
    };

    let thumbnailContainer;
    let thumbnailImage;

    if (thumbnail) {
      thumbnailContainer = document.createElement('div');
      thumbnailImage = document.createElement('img');
      thumbnailImage.setAttribute('tabindex', -1);
      thumbnailImage.setAttribute('aria-hidden', true);
    }

      // 3. This function creates an <iframe> (and YouTube player)
      //    after the API code downloads.
      let player;
      // eslint-disable-next-line no-unused-vars
      function onYouTubeIframeAPIReady() {
        // eslint-disable-next-line no-undef
        player = new YT.Player( $ytPlayer , {
          videoId,
          playerVars,
          events: {
            'onReady': onPlayerReady,
            'onStateChange': onPlayerStateChange,
          },
        });

        setElementInert(true, player.h);

        window.MSRecipeVideos[videoId] = player;

        if (thumbnail && ytContainer) {
          thumbnailContainer.classList.add('ms-yt-thumbnail__container');
          thumbnailImage.classList.add('ms-yt-thumbnail__image')
          thumbnailImage.src = `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`
          thumbnailContainer.appendChild(thumbnailImage);
          ytContainer.appendChild(thumbnailContainer);
        }
      }

      // 4. The API will call this function when the video player is ready.
      function onPlayerReady(event) {

        if (withVideoLabel) {
          ytContainer.setAttribute('aria-label', `Video: ${window.MSRecipeVideos[videoId].getVideoData().title}`);
        }

        // auto-play everywhere except recipe and wysiwyg videos
        if (!isRecipeVideo && !isWysiwygVideo && autoplay) {
          event.target.playVideo();
        }
      }

      // 5. The API calls this function when the player's state changes.
      //    The function indicates that when playing a video (state=1),
      //    the player should play for six seconds and then stop.
      function onPlayerStateChange(event) {
        // eslint-disable-next-line no-undef
        if (event.data === YT.PlayerState.ENDED && !(isRecipeVideo || isWysiwygVideo)) {
          restartVideo();
        }

        if (thumbnail) {
          if (event.data === window.YT.PlayerState.ENDED || event.data === window.YT.PlayerState.PAUSED) {
            thumbnailContainer.style.visibility = 'visible';
            thumbnailContainer.style.opacity = '1';
          } else {
            thumbnailContainer.style.visibility = 'hidden';
            thumbnailContainer.style.opacity = '0';
          }
        }

        // specific code for recipe media and wysiwyg video
        if (isRecipeVideo || isWysiwygVideo) {
          const parentFigure = player.getIframe().parentElement;

          if (event.data !== window.YT.PlayerState.PLAYING) {
            parentFigure.classList.add('paused');
          } else {
            parentFigure.classList.remove('paused');
          }
        }
      }

      function restartVideo() {
        player.playVideo();
      }

      // render video
      onYouTubeIframeAPIReady();
  },

  finalize() {
    window.MSRecipeVideos = {};
  },
}



// WEBPACK FOOTER //
// /private/var/www/Morton-Windsor/wp-content/themes/morton-salt/resources/assets/scripts/multisite/components/youtube-bg.js